
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.08 13.12a13.542 13.542 0 00-.866-2.841l.034.089a12.62 12.62 0 00-1.308-2.476l.028.044a19.53 19.53 0 00-1.795-2.115l.003.003a19.535 19.535 0 00-2.059-1.755l-.053-.037c-.7-.479-1.501-.909-2.347-1.25l-.085-.03a13.012 13.012 0 00-2.666-.818l-.086-.014c-.865-.203-1.859-.32-2.88-.32s-2.015.117-2.968.337l.088-.017a13.542 13.542 0 00-2.841.866l.089-.034A12.62 12.62 0 007.892 4.06l.044-.028a19.53 19.53 0 00-2.115 1.795l.003-.003a19.535 19.535 0 00-1.755 2.059l-.037.053c-.479.7-.909 1.501-1.25 2.347l-.03.085a13.012 13.012 0 00-.818 2.666l-.014.086c-.203.865-.32 1.859-.32 2.88s.117 2.015.337 2.968l-.017-.088c.201 1.044.489 1.966.866 2.841l-.034-.089a12.62 12.62 0 001.308 2.476l-.028-.044a19.53 19.53 0 001.795 2.115l-.003-.003a19.535 19.535 0 002.059 1.755l.053.037c.7.479 1.501.909 2.347 1.25l.085.03c.786.343 1.708.631 2.666.818l.086.014c.865.203 1.859.32 2.88.32s2.015-.117 2.968-.337l-.088.017a13.542 13.542 0 002.841-.866l-.089.034a12.62 12.62 0 002.476-1.308l-.044.028a19.53 19.53 0 002.115-1.795l-.003.003a19.535 19.535 0 001.755-2.059l.037-.053c.479-.7.909-1.501 1.25-2.347l.03-.085c.343-.786.631-1.708.818-2.666l.014-.086c.203-.865.32-1.859.32-2.88s-.117-2.015-.337-2.968l.017.088zm-7.04 4.096L16.256 24a.38.38 0 01-.512 0L8.96 17.216a.318.318 0 01.001-.448l1.6-1.6a.318.318 0 01.448.001l3.136 3.136V8.129a.32.32 0 01.32-.32h2.752a.32.32 0 01.32.32v10.432l3.456-3.392a.318.318 0 01.448.001l1.6 1.6a.318.318 0 01-.001.448z"}})])
          )
        }
      }
    